import { configureStore } from "@reduxjs/toolkit";
import { apiMiddleware, apiReducers } from "./api/apiSetup";
 
import authSlice from "./slices/authSlice";
 

// Create the store
export const store = configureStore({
  reducer: {
    
    auth: authSlice,
    
    ...apiReducers,
  },
  middleware: (getDefaultMiddleware:any) =>
    getDefaultMiddleware().concat(...apiMiddleware),
});

// Define RootState and AppDispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
